const messages = {
  title: 'Tu factura se generó con éxito',
  description: 'La factura generada ha sido enviada a {email}',
  downloadPdf: 'DESCARGA PDF',
  downloadXML: 'DESCARGA XML'
}

export default messages
